module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921062651_T.fcb55937.jpg";